import { render, staticRenderFns } from "./TaskDialogMinimal.vue?vue&type=template&id=71658d5d"
import script from "./TaskDialogMinimal.vue?vue&type=script&lang=js"
export * from "./TaskDialogMinimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports